/** @format */

import { Component, input } from '@angular/core';

@Component({
	selector: 'plp-components-skeleton-product-card',
	templateUrl: './skeleton-product-card.component.html',
	styleUrl: './skeleton-product-card.component.scss'
})
export class SkeletonProductCardComponent {
	compareCheckboxEnabled = input(false);
}
